import { render, staticRenderFns } from "./WYSIWYGEditor.vue?vue&type=template&id=4860f096&"
import script from "./WYSIWYGEditor.vue?vue&type=script&lang=js&"
export * from "./WYSIWYGEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports